import { request } from '../axios/request';

import {
  FETCH_PACKAGE_STOCK_LOCATIONS_PENDING,
  FETCH_PACKAGE_STOCK_LOCATIONS_REJECTED,
  FETCH_PACKAGE_STOCK_LOCATIONS_FULFILLED,
} from '../constants/packageStockLocations';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_PACKAGE_STOCK_LOCATIONS_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_PACKAGE_STOCK_LOCATIONS_FULFILLED,
  response,
});

const rejected = (error) => ({
  type: FETCH_PACKAGE_STOCK_LOCATIONS_REJECTED,
  error,
});

export const fetchPackageStockLocations = () => (dispatch) => {
  dispatch(pending());

  request({ method: 'GET', url: OMS.OMS.PACKAGE_STOCK_LOCATIONS })
    .then((response) => dispatch(fulfilled(response.data)))
    .catch((error) => dispatch(rejected(error)));
};



// WEBPACK FOOTER //
// ./src/actions/packageStockLocations.js